import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import "./CustomePhoneInput.scss";
import { useEffect, useState } from "react";

interface PhoneInputProps {
  placeHolder?: string;
  value: string;
  handlePhoneNumberChange: (phone: string, country: any) => void;
  errorFlag?: boolean;
  dial_code?: string;
  disabled?: boolean;
  className?:string
}

const CustomPhoneInput: React.FC<PhoneInputProps> = ({
  placeHolder,
  value,
  handlePhoneNumberChange,
  dial_code, disabled,className
}) => {
  const containsLetters = (str: string) => /[a-zA-Z]/.test(str);
  const [country, setCountry] = useState<string | null>(null);
  const [phoneKey, setPhoneKey] = useState(1)
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("user_country");

    if (saved) {
      setCountry(saved.toLowerCase());
      setReady(true);
      setPhoneKey((k) => k + 1);
      return;
    }

    // fetch live country
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const iso = data?.country_code?.toLowerCase() || "us";
        setCountry(iso);
        localStorage.setItem("user_country", iso);
        setReady(true);
        setPhoneKey((k) => k + 1);
      })
      .catch(() => {
        setCountry("us");
        setReady(true);
        setPhoneKey((k) => k + 1);
      });
  }, []);


  return (
    <div className="mb-2">
      {(!ready || !country) ? null :
        <PhoneInput
          inputStyle={{
            width: "100%",
            fontSize: "14px",
            height: "43px",
          }}
          key={phoneKey}
          preferredCountries={['ae', 'us', 'gb', 'in', 'jp', 'cn', 'ch', 'sg', 'ru', 'fr']}
          disabled={disabled || false}
          countrySelectorStyleProps={{
            buttonStyle: {
              height: "43px",
              borderTopLeftRadius: "4px",
              borderBottomLeftRadius: "4px",
            },
          }}
          defaultCountry={country ? country : 'us'}
          forceDialCode
          className={`custom-phone-input ${className}`}
          placeholder={placeHolder}
          value={
            value?.startsWith("+")
              ? value
              : `+${dial_code || ""}${value || ""}`
          }
          onChange={(phone: string, country: any) => {
            if (containsLetters(phone)) return;
            handlePhoneNumberChange(phone, country?.country);
          }}
        />}

    </div>
  );
};

export default CustomPhoneInput;